import { render, staticRenderFns } from "./test-results.vue?vue&type=template&id=1424e026&"
import script from "./test-results.vue?vue&type=script&lang=js&"
export * from "./test-results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports